import { render, staticRenderFns } from "./LeaveCarryForwardPolicyForm.vue?vue&type=template&id=a67be9b0"
import script from "./LeaveCarryForwardPolicyForm.vue?vue&type=script&lang=js"
export * from "./LeaveCarryForwardPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports